import type { FeatureRequestCategory, FeatureRequestStatus } from "../types";

export const FEATURE_REQUEST_CATEGORIES: {
  value: FeatureRequestCategory;
  label: string;
}[] = [
  { value: "github", label: "GitHub" },
  { value: "claude", label: "Claude" },
  { value: "compute-platform", label: "Compute Platform / Kubernetes" },
  { value: "developer-portal", label: "Developer Portal" },
  { value: "prod-atlas", label: "ProdAtlas" },
  { value: "devxhub", label: "DevXHub" },
  { value: "dependency-track", label: "DependencyTrack" },
  { value: "other", label: "Other" },
];

export function featureRequestCategoryLabel(value: string): string {
  return (
    FEATURE_REQUEST_CATEGORIES.find((c) => c.value === value)?.label ?? value
  );
}

export const FEATURE_REQUEST_STATUSES: {
  value: FeatureRequestStatus;
  label: string;
  badgeClasses: string;
}[] = [
  {
    value: "submitted",
    label: "Submitted",
    badgeClasses:
      "bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200",
  },
  {
    value: "planned",
    label: "Planned",
    badgeClasses:
      "bg-primary-100 text-primary-800 dark:bg-primary-900 dark:text-primary-200",
  },
  {
    value: "in-progress",
    label: "In progress",
    badgeClasses:
      "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  },
  {
    value: "blocked",
    label: "Blocked",
    badgeClasses:
      "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
  },
  {
    value: "done",
    label: "Done",
    badgeClasses:
      "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  },
  {
    value: "declined",
    label: "Declined",
    badgeClasses: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  },
];

// FEATURE_REQUEST_BOARD_STATUSES are the columns an admin can move a request
// to, in board order. Only those that map onto a column of this board are
// offered: the project also has Backlog, Refined, Review and Test, which
// collapse into Submitted, Planned and In Progress and would therefore send a
// request somewhere other than where it was put.
export const FEATURE_REQUEST_BOARD_STATUSES = [
  "Submitted",
  "Planned",
  "In Progress",
  "Blocked",
  "Done",
  "Declined",
] as const;

export function featureRequestStatusMeta(value: string) {
  return FEATURE_REQUEST_STATUSES.find((s) => s.value === value);
}

export function featureRequestStatusLabel(value: string): string {
  return featureRequestStatusMeta(value)?.label ?? value;
}

export function upcomingQuarters(count = 8): string[] {
  const now = new Date();
  let quarter = Math.floor(now.getMonth() / 3) + 1;
  let year = now.getFullYear();
  const quarters: string[] = [];
  for (let i = 0; i < count; i++) {
    quarters.push(`Q${quarter} ${year}`);
    quarter += 1;
    if (quarter > 4) {
      quarter = 1;
      year += 1;
    }
  }
  return quarters;
}
